import React from 'react'

import { cn } from '@/lib'

type BadgeStatus = 'waiting' | 'success' | 'primary' | 'danger'
interface BadgesProps {
  status?: BadgeStatus
  text: React.ReactNode
  className?: string
}

const Badge = ({ status, text, className = '' }: BadgesProps) => {
  let classStatus = ''
  switch (status) {
    case 'waiting':
      classStatus = 'bg-main-12 text-main-100'
      break
    case 'success':
      classStatus = 'bg-green-8 text-green-100'
      break
    case 'primary':
      classStatus = 'bg-primary/30'
      break
    case 'danger':
      classStatus = 'bg-red'
      break
  }
  return <div className={cn('rounded-full px-[6px] py-[3px] bg-main-12', classStatus, className)}>{text}</div>
}

export default Badge
